export const CHECK = "CHECK";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const SOFT_LOGOUT = "SOFT_LOGOUT";
export const REGISTER = "REGISTER";

export default {
    CHECK,
    LOGIN,
    LOGOUT,
    SOFT_LOGOUT,
    REGISTER
};
